import axios from "axios";

export const Dictionary = {
    namespaced: true,

    state: {
        cityOptions: [],
        typeOptions: [],
        specialityOptions: [],
        metroOptions: [],
        areaOptions: [],
        districtOptions: [],
        localityOptions: [],
        deletionReasonsOptions: []
    },

    mutations: {
        setDeletionReasonsOptions (state, data) {
            state.deletionReasonsOptions = data;
        },
        setSpecialityOptions (state, data) {
            state.specialityOptions = data;
        },
        setCityOptions (state, data) {
            state.cityOptions = data;
        },
        setMetroOptions (state, data) {
            state.metroOptions = data;
        },
        setTypeOptions (state, data) {
            state.typeOptions = data;
        },
        setAreaOptions (state, data) {
            state.areaOptions = data;
        },
        setLocalityOptions (state, data) {
            state.localityOptions = data;
        },
        setDistrictOptions (state, data) {
            state.districtOptions = data;
        }
    },

    actions: {
        fetchDeletionReasonsOptions: async function ({ state, commit }) {
            if (state.deletionReasonsOptions.length === 0) {
                axios.get('/dictionary/doctorDeletionReasons').then(response => {
                    commit('setDeletionReasonsOptions', response.data);
                });
            }
        },
        fetchSpecialityOptions: async function ({ state, commit }) {
            if (state.deletionReasonsOptions.length === 0) {
                axios.get('/dictionary/doctorSpeciality').then(response => {
                    commit('setSpecialityOptions', response.data);
                });
            }
        },
        fetchCityOptions: async function ({ state, commit }) {
            if (state.cityOptions.length === 0) {
                axios.get('/dictionary/city').then(response => {
                    commit('setCityOptions', response.data);
                });
            }
        },

        fetchMetroOptions: async function ({ state, commit }) {
            if (state.metroOptions.length === 0) {
                axios.get('/dictionary/metros').then(response => {
                    commit('setMetroOptions', response.data);
                });
            }
        },

        fetchTypeOptions: async function ({ state, commit }) {
            if (state.typeOptions.length === 0) {
                axios.get('/dictionary/clinicType').then(response => {
                    commit('setTypeOptions', response.data);
                });
            }
        },

        fetchAreaOptions: async function ({ state, commit }) {
            if (state.areaOptions.length === 0) {
                axios.get('/dictionary/area').then(response => {
                    commit('setAreaOptions', response.data);
                });
            }
        },

        fetchLocalityOptions: async function ({ state, commit }) {
            if (state.localityOptions.length === 0) {
                axios.get('/dictionary/locality').then(response => {
                    commit('setLocalityOptions', response.data);
                });
            }
        },

        fetchDistrictOptions: async function ({ state, commit }) {
            if (state.districtOptions.length === 0) {
                axios.get('/dictionary/district').then(response => {
                    commit('setDistrictOptions', response.data);
                });
            }
        },
        fetchAllOptions: function ({ dispatch }) {
            dispatch('fetchCityOptions');
            dispatch('fetchMetroOptions');
            dispatch('fetchTypeOptions');
            dispatch('fetchAreaOptions');
            dispatch('fetchLocalityOptions');
            dispatch('fetchDistrictOptions');
        }
    }
};
